/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerZaehlerDto } from '../../models/lexplus-benutzer-zaehler-dto';

export interface BenutzerverwaltungControllerCountByStatusV1$Params {
}

export function benutzerverwaltungControllerCountByStatusV1(http: HttpClient, rootUrl: string, params?: BenutzerverwaltungControllerCountByStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerZaehlerDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerCountByStatusV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerZaehlerDto>;
    })
  );
}

benutzerverwaltungControllerCountByStatusV1.PATH = '/v1/benutzerverwaltung/zaehler';
